import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import FilterBar from "app/components/FilterBar";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
import Canvas from "app/components/Canvas";
import ColorWheel from "app/components/ColorWheel";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import momentActions from "app/utils/momentActions";
import prefActions from "app/utils/prefActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
} from "app/utils/styleSheet";

import Draggable from "app/components/Draggable";
import ValueListItem from "app/components/ValueListItem";
import ButtonGroup from "app/components/ButtonGroup";

import MomentBullet from "app/components/chapter/MomentBullet";
import MomentList from "app/components/chapter/MomentList";

import store from "app/redux/store";

import Hoverable from "app/components/Hoverable";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class Mountain extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props, context);

    let { values, app, filters } = store.getState();
    let { loading, datetime } = app;
    let rawValues = values;
    let condensedValues = valueHelpers.condenseAllRevisions(values);

    this.state = {
      values: condensedValues,
      rawValues,
      loading: true,
      filters,
      moments: [],
      weightedValues: [],
      expandedIds: [],
      numberOfWeeks: 2,
    };
  }

  async componentDidMount() {
    this.subscribe();
    this.fetch();
  }

  fetch = async () => {
    let { numberOfWeeks } = this.state;
    let res = await momentActions.index(numberOfWeeks);
    if (res?.success) {
      let weightedValues = res.values
        .map((v) => {
          return {
            ...v,
            moments: res.moments.filter((m) => m.value_id == v.id),
          };
        })
        .sort((a, b) =>
          a.moments.filter((m) => !!m.completed_at).length <
          b.moments.filter((m) => !!m.completed_at).length
            ? 1
            : -1,
        );
      this.setState({ loading: false, moments: res.moments, weightedValues });
    }
  };

  subscribe = async () => {
    this.unsubscribe = store.subscribe(() => {
      let { values, app, preferences, filters } = store.getState();
      let { loading, datetime } = app;
      if (
        JSON.stringify(values) != JSON.stringify(this.state.rawValues) ||
        JSON.stringify(filters) != JSON.stringify(this.state.filters)
      ) {
        let rawValues = values;
        values = values.filter((v) => !preferences?.hiddenIds?.includes(v?.id));
        console.error("update values", values.length);
        console.log(
          "expanded ids",
          this.state.expandedIds,
          values.filter(
            (v) =>
              !!v.parent_ids.filter((pid) =>
                this.state.expandedIds.includes(pid),
              ).length,
          ),
        );
        // values = filterHelpers.apply(values);
        // let condensedValues = valueHelpers.condenseAllRevisions(values);
        this.setState({
          // values: condensedValues,
          values,
          rawValues,
          loading,
          filters,
        });
      }
    });

    // focus
    this.unsubscribeFocus = this.props.navigation.addListener(
      "focus",
      this.handleFocus,
    );
    if (ENV.WEB) window.addEventListener("focus", this.handleFocus);
    this.unsubscribeBlur = this.props.navigation.addListener(
      "blur",
      this.unsubscribe,
    );
    if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);
  };

  componentWillUnmount() {
    // this.props.navigation.removeListener("focus");
    this.unsubscribeFocus();
    if (ENV.WEB) window.removeEventListener("focus", this.handleFocus);
    // this.props.navigation.removeListener("blur");
    this.unsubscribeBlur();
    if (ENV.WEB) window.removeEventListener("blur", this.handleFocus);
    this.unsubscribe();
  }

  handleFocus = () => {
    console.log("focus");
    this.subscribe();
    // this.updateView(false);
  };

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    let { values, loading, expandAll, moments, weightedValues, numberOfWeeks } =
      this.state;

    return (
      <View style={[this.styles().container]}>
        <StatusBar style="auto" />

        <View style={{ height: this.context.sizes.base }} />

        <ScrollView style={this.styles().scroller}>
          <View style={this.styles().contentWrapper}>
            <View style={this.styles().content}>
              {loading && !moments?.length ? (
                <ActivityIndicator />
              ) : (
                this.renderList(weightedValues, 0)
              )}
            </View>
            <Text>Showing the past {numberOfWeeks} weeks</Text>
          </View>
        </ScrollView>
      </View>
    );
  }

  renderList = (weightedValues) => {
    return weightedValues.map((wv, i) => {
      let moments = wv.moments;
      let completedMoments = moments.filter((m) => !!m.completed_at);
      let title = `(${completedMoments.length}/${moments.length}) ${wv.title}`;
      let value = { ...wv, title };
      return <Value key={`${i}-${wv.id}`} value={value} />;
      return <MomentBullet key={`${i}-${wv.id}`} moment={{ value }} />;
      // return <ValueListItem key={`${i}-${moment.id}`} value={moment.value} />;
    });
  };

  toggleExpanded = (id) => {
    let { expandedIds } = this.state;
    if (expandedIds.includes(id)) {
      expandedIds.splice(expandedIds.indexOf(id), 1);
    } else {
      expandedIds.push(id);
    }
    console.log(
      "expanded ids",
      expandedIds,
      this.state.values.filter(
        (v) => !!v.parent_ids.filter((pid) => expandedIds.includes(pid)).length,
      ),
    );
    this.setState({ expandedIds });
  };

  focusNext = async (
    id,
    expanded,
    peers,
    index,
    children,
    uncles,
    parentIndex,
  ) => {
    console.log("focus next");
    let nextId;
    if (expanded && children.length) {
      // first child
      nextId = children[0].id;
    } else if (peers.length && peers.length - 1 > index) {
      // next peer
      nextId = peers[index + 1].id;
    } else {
      // next uncle
      nextId = uncles[parentIndex + 1]?.id;
    }
    if (nextId && this[`ref-${nextId}`]) {
      let ref = this[`ref-${nextId}`];
      if (!!ref?.focus) {
        // ref.addEventListener('focus', this.cursorToBeginning)
        await this.setState({ hideCaret: true });
        ref.focus();
        await new Promise((resolve) => setTimeout(resolve, 0));
        ref?.setSelectionRange && ref.setSelectionRange(0, 0);
        await this.setState({ hideCaret: false });
        // ref.removeEventListener('focus', this.cursorToBeginning)
      }
    } else {
      console.log("not found", nextId, this.refs);
    }
  };

  cursorToBeginning = (event) => {
    console.log(
      "listener",
      event?.target?.setSelectionRange,
      event?.srcElement?.setSelectionRange,
    );
    let ref = event?.target;
    ref?.setSelectionRange && ref.setSelectionRange(0, 0);
    ref?.setSelectionRange
      ? console.log("cursor to beginning")
      : console.log("no ref found");
  };

  focusPrevious = (id, peers, index, parent) => {
    console.log("focus previous");
    let prevId;
    if (peers.length && index > 0) {
      // prev peer
      prevId = peers[index - 1].id;
    } else {
      // parent
      prevId = parent.id;
    }
    if (prevId && this[`ref-${prevId}`]) {
      console.log(prevId, this[prevId]);
      this[`ref-${prevId}`].focus && this[`ref-${prevId}`].focus();
    } else {
      console.log("not found", prevId, this.refs);
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      // alignItems: 'center',
      // alignItems: 'stretch',
    },
    contentWrapper: {
      // flexDirection: "row",
      justifyContent: "center",
      // alignItems: "flex-start",
      alignItems: "center",
      flex: 1,
    },
    content: {
      flex: 1,
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      // alignSelf: 'center',
      // alignItems: 'center',
      // flex: 1,
      // borderWidth: 1, borderColor: 'red',
      // maxWidth: WIDTH/2,
    },
    scroller: {
      padding: this.context.sizes.base,
    },
    list: {
      // alignSelf: 'center',
      // borderWidth: 1, borderColor: 'green',
      marginLeft: this.context.sizes.large,
      // alignSelf: 'flex-start',
    },
    row: {
      flexDirection: "row",
      // alignItems: 'center',
      // justifyContent: 'space-between',
      borderColor: this.context.colors.trim,
      // borderBottomWidth: 1,
      borderLeftWidth: 1,
      flex: 1,
    },
    valueWrapper: {
      flex: 1,
      flexDirection: "row",
      // alignSelf: 'stretch',
      // flexGrow: 0,
      // justifyContent: 'center',
      // alignItems: 'center',
      // borderColor: 'red', borderWidth: 2,
      padding: 5,
      paddingLeft: 0,
    },
    bullet: {
      width: this.context.sizes.large,
      height: this.context.sizes.large,
      textAlign: "center",
      fontSize: 12,
      borderWidth: 0.5,
      borderColor: this.context.colors.trim,
      borderRadius: this.context.sizes.large / 2,
      marginHorizontal: 3,
    },
    textInput: {
      flex: 1,
      // width: 399,
    },
    sliderRow: {
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: this.context.sizes.base,
      marginBottom: this.context.sizes.base,
      height: 50,
    },
    button: {
      padding: this.context.sizes.base,
      borderRadius: this.context.sizes.smallBorderRadius,
      backgroundColor: this.context.colors.fill,
      marginRight: this.context.sizes.base,
    },
    selectedButton: {
      backgroundColor: this.context.colors.trim,
    },
    buttonGroup: {
      flexDirection: "row",
      borderRadius: this.context.sizes.smallBorderRadius,
      overflow: "hidden",
      marginRight: this.context.sizes.base,
    },
    groupedButton: {
      borderRadius: 0,
      marginRight: 0,
    },
  });
}
